import { asyncComponent } from 'react-async-component';

const TrykTestingLayout = asyncComponent<{}>({
  resolve: () => import('./Layout').then(x => x.default)
});

export default TrykTestingLayout;
